import React, { useContext } from "react";
import { string, arrayOf, shape } from "prop-types";
import { PageContext } from "../PageContext";
// eslint-disable-next-line import/no-cycle
import { LPCSearch } from "./LPCSearch";
import { RCL as useTranslation } from "../RCL";

// eslint-disable-next-line react/prop-types
const LPCConnector = ({ data }) => {
	const pageContext = useContext(PageContext);

	return (
		<LPCSearch
			durationOptions={data.durationOptions}
			labels={{
				title: useTranslation({ searchKey: "lowest-price-calendar" }),
				details: useTranslation({
					searchKey: "this-convenient-tool-helps-you-find-the-best-deals-on-vacation-packages-to",
				}),
				subTitle: useTranslation({
					searchKey: "find-the-best-price-for-your-vacation-and-book-now",
				}),
				select: useTranslation({ searchKey: "select" }),
				from: useTranslation({ searchKey: "from" }),
				to: useTranslation({ searchKey: "to" }),
				hotel: useTranslation({ searchKey: "hotel" }),
				departing: useTranslation({ searchKey: "departing-month" }),
				goingFor: useTranslation({ searchKey: "going-for" }),
				search: useTranslation({ searchKey: "search" }),
			}}
			lang={pageContext.locale.slice(0, 2)}
		/>
	);
};
LPCConnector.propTypes = {
	data: shape({
		durationOptions: arrayOf(
			shape({
				label: string,
				value: string,
			})
		),
	}).isRequired,
};

export default LPCConnector;
export { LPCConnector };
